import { render } from "./statement-of-account-listing.vue?vue&type=template&id=7a57b821"
import script from "./statement-of-account-listing.vue?vue&type=script&lang=js"
export * from "./statement-of-account-listing.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__